import React, { useEffect, useState } from 'react';
import { FlexContainer, FlexRow, ScrollContainer, ScrollLine, ScrollText, ProjectTitle } from '../Styles';
import CompanyItem from '../Component/Components/companyItem';

import customQuiz from './../assets/Projects/CustomQuiz.webp';
import ServoCMP from './../assets/Projects/ServoCMP.webp';
import TwitterRed from './../assets/Projects/TwitterRed.webp';
import MADProject from './../assets/Projects/MADProject.webp';
import StandWeSpeak from './../assets/Projects/StandWeSpeak.webp';
import StandWeSpeakApp from './../assets/Projects/StandWeSpeakAndroid.webp';
import VIDUR from './../assets/Projects/VidurSystem.webp';
import AviciaPorfolio from './../assets/Projects/AviciaPortfolio.webp';
import StevenPortfolio from './../assets/Projects/StevenPortfolio.webp';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './mob-style.css';

const ProjectPage = () => {

    const projects = [
        {
            name: 'ServoCMP',
            date: 'Jun\' 2018 - Feb\' 2019',
            languages: '#JAVA#JSP#JQUERY#HTML#ORACLE',
            about: 'ServoCMP is a process automated web application build sole for the purpose for processing oil testing results and deliver the outcome to customers as per requested',
            point: `<section><ul><h4 style="margin: 0px">Features</h4><li>Multi User Types</li><li>Concurrent Transactions</li><li>Graphical Visualisation of reports</li></ul></section>`,
            img: ServoCMP
        },
        {
            name: 'Multi-Lang Quiz',
            date: 'Sep\' 2018 - Nov\' 2018',
            languages: '#JAVA#JSP#JQUERY#HTML#ORACLE',
            about: `Multi-Lang Quiz is a simple quiz which is built for hosting multi choice question for a small group of audience. 
            Build using Java, JQuery, Bootstrap and few other js libraries.`,
            point: `<section><ul><h4 style="margin: 0px">Features</h4><li>Quick access to all questions</li><li>Easy Question Bank uploading</li></ul></section>`,
            img: customQuiz
        },
        // {
        //     name: 'HindiSw',
        //     date: 'Jul\' 2018 - Aug\' 2018',
        //     languages: '#ORACLE#JAVA#JSP#JQUERY#HTML',
        //     about: `A Java Web App similar to the quiz app. Made for hosting hindi 
        //         comprehension by using file uploading and also tracking user by cursor movement.`,
        //     point: `<section><ul><h4 style="margin: 0px">Features</h4><li>File Upload and management</li><li>Multiple Test Hosting</li></ul></section>`,
        //     img: ''
        // },
        {
            name: 'VIDUR (Virtual Interface For Dialysis Unit Review)',
            date: 'Jun\' 2018 - Sep\' 2018',
            languages: '#MYSQL#JAVA#JSP#JQUERY#HTML',
            about: 'The goal of the project was to store individual personal records of the company and record their dialysis readings and appointment. Such reading would be collected and manipulated into visualize form to help the doctors who are assigned to most patient view their data/records when needed.',
            point: `<section><ul><h4 style="margin: 0px">Features</h4><li>Admin interface</li><li>Storing huge client records</li><li>Minimum Security</li></ul></section>`,
            img: VIDUR
        },
        {
            name: 'StandWeSpeak Website & Backend Server',
            date: 'Jul\' 2019 - Oct\' 2019',
            languages: `#HTML#REACTJS#NODEJS #MONGODB#AWS`,
            about: 'Offical website of Standwespeak',
            point: `<section><ul><h4 style="margin: 0px">Features</h4><li>Automated Appointment Booking</li><li>Payment-Gateway/Calendar Integration</li><li>Social Integration</li></ul></section>`,
            img: StandWeSpeak
        },
        {
            name: 'StandWeSpeak App',
            date: 'Nov\' 2020 - Mar\' 2021',
            languages: '#JSX#REACTNATIVE #GOOGLECONSOLE',
            about: 'An Android app made solely for the purpose of serving blogs, products, and videos of the company.',
            point: `<section><ul><h4 style="margin: 0px">Features</h4><li>Social Integration</li><li>Flexible UI</li><li>Beautiful Layout</li></ul></section>`,
            img: StandWeSpeakApp
        },
        {
            name: 'Virtual Attendance App (VA-App)',
            date: 'Nov\' 2020 - Mar\' 2021',
            languages: '#ANDROID#JAVA#XML#FIREBASE',
            about: 'VA-App is an android application build using java and xml language on android studio. It has an external API server to communicate for scanning and face recognition purpose',
            point: `<section><ul><h4 style="margin: 0px">Features</h4><li>Social Integration</li><li>Flexible/Dynamic UI</li><li>Beautiful Design</li></ul></section>`,
            img: MADProject
        },
        {
            name: 'Twitter Red',
            date: 'Feb\' 2020 - Feb\' 2020',
            languages: '#ANDROID#JAVA#XML#FIREBASE',
            about: 'Twitter Red is a clone of the offical Twitter Website which is build using python and flask technology. With a in-built search engine + NLP it can find optimal search result than original site',
            point: `<section><ul><h4 style="margin: 0px">Features</h4><li>Social Integration</li><li>Flexible/Dynamic UI</li><li>Beautiful Design</li></ul></section>`,
            img: TwitterRed
        },
        {
            name: 'Portfolio',
            date: 'Nov\' 2020 - Nov\' 2020',
            languages: '#REACTJS#GITHUB',
            about: 'One of portfolio page made for one of my clients',
            point: `<section><ul><h4 style="margin: 0px">Features</h4><li>Flexible/Dynamic UI</li><li>Gallery View</li><li>Smooth Animations</li></ul></section>`,
            img: AviciaPorfolio
        },
        {
            name: 'Portfolio',
            date: 'Nov\' 2020 - Nov\' 2020',
            languages: '#REACTJS#GITHUB#FIGMA',
            about: 'My Official Porfolio',
            point: `<section><ul><h4 style="margin: 0px">Features</h4><li>Email System</li><li>Flexible UI</li><li>Smooth Animations</li></ul></section>`,
            img: StevenPortfolio
        }
    ]

    const [screenSize, setscreenSize] = useState(window.innerWidth);

    const resizeWindow = () => {
        if (window.innerWidth !== screenSize) {
            setscreenSize(window.innerWidth);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("resize", resizeWindow);
    }, [])

    return (
        <FlexContainer>
            <ScrollContainer top="4px" left="49%">
                {
                    screenSize > 1200 ?
                        <ScrollLine top={'200px'} ></ScrollLine> : null
                }
                <ScrollText
                    style={{
                        fontSize: 36, background: 'linear-gradient(190deg, rgb(0 11 35), rgb(0 12 37))',
                        lineHeight: 3, top: '40px', left: '50%', transform: 'translateX(-50%)', width: 'max-content'
                    }} className="project-title">
                    COMPANY/PERSONAL PROJECTS
                    </ScrollText>
            </ScrollContainer>
            <div style={{ marginTop: 160, marginBottom: 300 }}>
                <ProjectTitle>Indian Oil Company Limited</ProjectTitle>
                <FlexRow justify={"space-between"}>
                    <CompanyItem info={projects[0]} />
                    <CompanyItem info={projects[1]} shiftIt={screenSize < 1200 ? "no" : "yes"} />
                </FlexRow>
                {/* <FlexRow justify={"flex-start"}>
                    <CompanyItem position="flex-start" info={projects[2]} />
                </FlexRow> */}
            </div>
            <div style={{ marginTop: 250 }}>
                <ProjectTitle>The Renal Project</ProjectTitle>
                <FlexRow justify={"flex-start"}>
                    <CompanyItem info={projects[2]} />
                </FlexRow>
            </div>
            <div style={{ marginTop: 50, marginBottom: 300 }}>
                <ProjectTitle>StandWeSpeak</ProjectTitle>
                <FlexRow justify={"space-between"}>
                    <CompanyItem info={projects[3]} />
                    <CompanyItem info={projects[4]} shiftIt={screenSize < 1200 ? "no" : "yes"} />
                </FlexRow>
            </div>
            <div style={{ marginTop: 250, marginBottom: 300 }}>
                <ProjectTitle>Portfolio</ProjectTitle>
                <FlexRow justify={"space-between"}>
                    <CompanyItem info={projects[7]} />
                    <CompanyItem info={projects[8]} shiftIt={screenSize < 1200 ? "no" : "yes"} />
                </FlexRow>
            </div>
            <div style={{ marginTop: 250, marginBottom: 300 }}>
                <ProjectTitle>Others</ProjectTitle>
                <FlexRow justify={"space-between"}>
                    <CompanyItem info={projects[5]} />
                    <CompanyItem info={projects[6]} shiftIt={screenSize < 1200 ? "no" : "yes"} />
                </FlexRow>
            </div>
        </FlexContainer >
    );
}


export default ProjectPage;